import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        mapWrapper: {
            width: '100%',
            height: '100%',
            position: 'relative',
        },
        mapWrapperFixed: {
            position: 'fixed',
            width: '50%',
            height: '80vh',
        },
        toolbar: {
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: 12,
        },
        rank: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
        },
        rankHeader: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
        },
        name: {
            fontSize: 16,
        },
        chip: {
            height: 22,
            fontSize: 11,
            fontWeight: 600,
            color: theme.palette.colors.white,
        },
        chipActive: {
            backgroundColor: theme.palette.success.main,
        },
        chipInactive: {
            backgroundColor: theme.palette.colors.greyDark,
        },
        chipClosed: {
            backgroundColor: theme.palette.danger.main,
        },
        chipCategory: {
            height: 22,
            fontSize: 11,
            fontWeight: 600,
            borderColor: theme.palette.colors.greySeparator,
            color: theme.palette.colors.table.text,
        },
        // A fixed template rather than a wrapping flexbox: every rank then lines up column
        // by column, whatever the width of its dispatch groups or its opening hours.
        details: {
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 2fr) minmax(0, 0.7fr) minmax(0, 1.2fr) minmax(0, 1.2fr) minmax(0, 1.6fr)',
            columnGap: 24,
            rowGap: 12,
            marginTop: 12,
            [theme.breakpoints.down('sm')]: {
                gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
            },
        },
        detail: {
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0, // lets a long value wrap inside its column instead of widening it
        },
        detailLabel: {
            fontSize: 12,
            fontWeight: 500,
            color: theme.palette.primary.dark,
        },
        detailValue: {
            fontSize: 14,
            color: theme.palette.colors.table.text,
            whiteSpace: 'pre-line', // keeps one opening hours group per line
            wordBreak: 'break-word',
        },
        detailEmpty: {
            color: theme.palette.colors.greyDark,
        },
    }),
);

export default useStyles;
